import React from "react";
import FormCom from "../../Components/InstructionsComNewUser/FormCom";
import { NewUserContextProvider } from "../../APIContext/NewUserContext";
import SEO from "../../Components/SEO";

function InstructionsFormNewUser() {
  return (
    <div
      className="bg-custom"
      style={{
        minHeight: "calc(100vh - var(--header-height))",
        filter: "brightness(1.28)",
      }}
    >
      <NewUserContextProvider>
        <FormCom />
      </NewUserContextProvider>
    </div>
  );
}

export default InstructionsFormNewUser;
